function submitTyreInsurance(event, cartEntryIndex,noOfMonth) {
    event.preventDefault();
    var data = {}
    data["cartEntryIndex"] = cartEntryIndex;
    data["noOfMonth"] = noOfMonth;
    postCartData(data,'/submit/cart/insurance', event);
};

function displayInsuranceInfoBox(data){
    $.fancybox({
        width: 700,
        height: 300,
        content : data,
        fitToView : true,
        autoSize : false,
        helpers : {
            overlay : {
                locked : false
            }
        }
    });
}